import React from "react";
import MarketingLayout from "@/components/marketing/MarketingLayout";
import { Button } from "@/components/ui/button";
import { ArrowRight, TrendingUp, Layers, Target, Building2 } from "lucide-react";

export default function Investors() {
  return (
    <MarketingLayout>
      <section className="pt-28 pb-12 max-w-5xl mx-auto px-6 lg:px-10">
        <p className="text-xs uppercase tracking-[0.2em] text-[#2C6BAC] font-semibold mb-4">Investors</p>
        <h1 className="font-display text-5xl lg:text-6xl tracking-tighter text-[#1A1A2E] leading-[0.95]">
          A wedge into a $5B+<br />workforce analytics market.
        </h1>
        <p className="mt-6 text-lg text-[#555568] max-w-3xl leading-relaxed">
          WYLO sits at the intersection of three durable trends: privacy-first SaaS, behavioural AI, and the
          permanent reorganisation of how knowledge work happens.
        </p>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 md:grid-cols-2 gap-5 py-8">
        {[
          { icon: TrendingUp, title: "Market", body: "Workforce analytics - $5B+ TAM, growing on the back of remote/hybrid permanence and HR-tech investment cycles." },
          { icon: Layers, title: "The gap", body: "No incumbent addresses physical interruptions, behavioural-AI refocus, and enterprise analytics in one privacy-first platform." },
          { icon: Target, title: "Differentiation", body: "The FACE framework, URL-hashed architecture, and a tiered model that compounds from individual to enterprise." },
          { icon: Building2, title: "Strategic optionality", body: "Acquisition-relevant to Microsoft Viva, Salesforce, and SAP. Operationally durable as a standalone." },
        ].map((b, i) => (
          <div key={i} className="rounded-xl border border-[#E8ECF2] bg-white p-7" data-testid={`investor-card-${i}`}>
            <div className="h-12 w-12 rounded-md bg-[#1A3A5C] text-white flex items-center justify-center">
              <b.icon size={20} />
            </div>
            <h3 className="font-display text-xl font-bold text-[#1A1A2E] mt-5">{b.title}</h3>
            <p className="text-sm text-[#555568] mt-3 leading-relaxed">{b.body}</p>
          </div>
        ))}
      </section>

      <section className="max-w-5xl mx-auto px-6 lg:px-10 py-16">
        <div className="rounded-xl bg-[#1A3A5C] text-white p-10 lg:p-14">
          <p className="text-xs uppercase tracking-[0.2em] text-[#E8ECF2]/70 font-semibold mb-4">Trajectory</p>
          <h2 className="font-display text-3xl lg:text-4xl tracking-tighter leading-[1.1]">
            $20M – $100M ARR over 5–7 years with disciplined execution.
          </h2>
          <p className="mt-6 text-[#E8ECF2]/80 max-w-3xl leading-relaxed">
            Bottoms-up pricing across the WYLO tier ladder, an explicit privacy-first moat in a market shifting toward EU AI Act compliance,
            and a defensible behavioural model that compounds with usage. Acquisition optionality at the upper end of the trajectory.
          </p>
          <div className="mt-8">
            <a
              href="mailto:investor.interest@usewylo.com?subject=Investor%20Inquiry%20%E2%80%94%20WYLO"
              data-testid="investor-contact-cta"
            >
              <Button className="bg-white text-[#1A3A5C] hover:bg-[#E8ECF2]">
                For more information, financial and investor resources, click here <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </a>
          </div>
          <p className="mt-6 text-xs text-[#E8ECF2]/60">
            Investor materials are shared directly via email on request. No financial documents are hosted publicly.
          </p>
        </div>
      </section>
    </MarketingLayout>
  );
}
